import { IonIcon } from "@ionic/react";
import { Link } from "react-router-dom";


const IconMenuItem = ({ icon, to, hasNotif = false }) => (
    <Link
        className="flex flex-col justify-center items-center bg-transparent md:flex-row"
        to={to}
    >
        <IonIcon
            className="bg-white stroke-current text-black text-lg p-2 rounded-full"
            src={icon}
        />
        {hasNotif && (
            <div className="bg-redNotif relative bottom-7 -right-1.5 md:bottom-1.5 md:right-4 rounded w-2 h-2" />
        )}
    </Link>
)

export default IconMenuItem;